import { render, staticRenderFns } from "./AddResellerComponent.vue?vue&type=template&id=89fbb04e"
import script from "./AddResellerComponent.vue?vue&type=script&lang=js"
export * from "./AddResellerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports